export const PaymentEvents = {
  Loaded: 'lib:loaded',
  LoadError: 'lib:loadError',
  ElementError: 'lib:elementError',
  FormChanged: 'form:changed',
  FormInvalid: 'form:invalid',
  FormComplete: 'form:complete',
  FormEmpty: 'form:empty',
  FormUnknown: 'form:unknown',
};

export type TPaymentEventType = typeof PaymentEvents[keyof typeof PaymentEvents];
export type TPaymentEventHandler = (...events: any[]) => void;

export interface IPaymentEvent {
  on(type: TPaymentEventType, handler: TPaymentEventHandler): void;
  off(type: TPaymentEventType, handler: TPaymentEventHandler): void;
  emit(type: TPaymentEventType, ...events: any[]): void;
}

class EventEmitter implements IPaymentEvent {
  private handlers: Record<string, TPaymentEventHandler[]> = {};

  on(type: TPaymentEventType, handler: TPaymentEventHandler) {
    (this.handlers[type] || (this.handlers[type] = [])).push(handler);
  }

  off(type: TPaymentEventType, handler?: TPaymentEventHandler) {
    if (!handler) {
      this.handlers[type] = [];
      return;
    }

    const index = this.handlers[type] && this.handlers[type].indexOf(handler);
    if (index !== -1) this.handlers[type].splice(index, 1);
  }

  emit(type: TPaymentEventType, ...events: any[]) {
    (this.handlers[type] || [])
      .forEach((handler: TPaymentEventHandler) => {
        handler(...events);
      });
  }
}

export const emitter = new EventEmitter();
